var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltipStop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.106136 0.106009C0.247602 -0.0353861 0.476905 -0.035329 0.6183 0.106136L7.89037 7.38183C8.03176 7.52329 8.0317 7.7526 7.89024 7.89399C7.74877 8.03539 7.51947 8.03533 7.37807 7.89386L0.106009 0.618173C-0.0353861 0.476707 -0.035329 0.247404 0.106136 0.106009Z",
    fill: "#DE350B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89024 0.106009C8.0317 0.247404 8.03176 0.476707 7.89037 0.618173L0.6183 7.89386C0.476905 8.03533 0.247602 8.03539 0.106136 7.89399C-0.035329 7.7526 -0.0353861 7.52329 0.106009 7.38183L7.37807 0.106136C7.51947 -0.035329 7.74877 -0.0353861 7.89024 0.106009Z",
    fill: "#DE350B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipStop);
export default __webpack_public_path__ + "static/media/tooltip_stop.712d8d21928445976d10295e9013d82b.svg";
export { ForwardRef as ReactComponent };